<div class="text-center">
  <img src="assets/spinner.svg" alt="loading" />
  <p class="gray">{{ 'GENERAL_LOADING' | translate }}</p>
</div>
